import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'

import { Auth } from 'aws-amplify'

import { Input } from 'antd'
import { Button } from 'antd'
import { Progress } from 'antd'
import { message } from 'antd'
import { Row } from 'antd'
import { Col } from 'antd'
import Tooltip from '@material-ui/core/Tooltip'

import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { MailOutlined } from '@ant-design/icons'
import { LockOutlined } from '@ant-design/icons'
import {
  updateAuthData,
  LOGED_IN,
  LOGED_OUT,
  CHANGE_PASSWORD_CHALLENGE,
  EMAIL_VERIFICATION_CHALLENGE,
} from 'store/auth/auth'
import tychoLogo from 'assets/tycho-logo.png'
import './changePassword.css'

const Password = Input.Password

function ChangePassword() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')
  const [isLoggingIn, setIsLoggingIn] = useState(false)
  const [passwordStrengthAverage, setPasswordStrengthAverage] = useState(0)
  const [samePasswordAverage, setSamePasswordAverage] = useState(0)
  const [passwordStrengthStatus, setPasswordStrengthStatus] = useState('exception')
  const [samePasswordStatus, setSamePasswordStatus] = useState('exception')
  const [samePassword, setSamePassword] = useState(false)
  const [correctPassword, setCorrectPassword] = useState(false)

  const authData = useSelector((state) => state.auth.authData)

  const dispatch = useDispatch()

  const verifyPasswordStrength = (value) => {
    setNewPassword(value)
    const minLength = /.{8,}/
    const specialCharacter = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/
    const uppercaseLetter = /[A-Z]/
    const lowercaseLetter = /[a-z]/
    const numberCharacter = /[0-9]/

    if (
      value.match(minLength) &&
      value.match(specialCharacter) &&
      value.match(uppercaseLetter) &&
      value.match(lowercaseLetter) &&
      value.match(numberCharacter)
    ) {
      setPasswordStrengthAverage(100)
      setPasswordStrengthStatus('success')
      setCorrectPassword(true)
    }

    if (
      !value.match(minLength) ||
      !value.match(specialCharacter) ||
      !value.match(uppercaseLetter) ||
      !value.match(lowercaseLetter) ||
      !value.match(numberCharacter)
    ) {
      setPasswordStrengthAverage(0)
      setPasswordStrengthStatus('exception')
      setCorrectPassword(true)
    }
  }

  const verifySamePassword = (value) => {
    setConfirmNewPassword(value)
    if (value === newPassword) {
      setPasswordStrengthAverage(100)
      setPasswordStrengthStatus('success')
      setCorrectPassword(true)
    } else {
      setPasswordStrengthAverage(0)
      setPasswordStrengthStatus('exception')
    }
  }

  const changePasswordSuccess = async (user) => {
    const groups = user.signInUserSession.accessToken.payload['cognito:groups']
    const emailVerified = user.signInUserSession.idToken.payload['email_verified']
    const email = user.signInUserSession.idToken.payload['email']
    const jwtToken = user.signInUserSession.accessToken['jwtToken']
    const isAuthenticated = true

    dispatch(
      updateAuthData({
        groups: groups,
        emailVerified: emailVerified,
        email: email,
        jwtToken: jwtToken,
        authStatus: LOGED_OUT,
      }),
    )

    setEmail('')
    setPassword('')
    setIsLoggingIn(false)
  }

  const chatchChangePasswordError = (err) => {
    if (err.code === 'InvalidPasswordException') {
      message.error(err.message)
      setEmail('')
      setPassword('')
      setNewPassword('')
      setConfirmNewPassword('')
      setIsLoggingIn(false)
    } else {
      // eslint-disable-next-line
      console.log(err)
    }
  }

  const loginSuccess = async (user) => {
    Auth.completeNewPassword(user, newPassword, { email: authData.email })
      .then((user) => changePasswordSuccess(user))
      .catch((err) => chatchChangePasswordError(err))
  }

  const catchLoginError = (err) => {
    if (err.code === 'NotAuthorizedException') {
      message.error('INVALID USER AND PASSWORD')
      setEmail('')
      setPassword('')
      setNewPassword('')
      setConfirmNewPassword('')
      setIsLoggingIn(false)
    } else {
      // eslint-disable-next-line
      console.log(err)
    }
  }

  const submitLogin = () => {
    if (correctPassword) {
      if (password !== newPassword) {
        if (newPassword === confirmNewPassword) {
          setIsLoggingIn(true)
          Auth.signIn(authData.email, password)
            .then((user) => loginSuccess(user))
            .catch((err) => catchLoginError(err))
        } else {
          message.warning('Las contraseñas no son iguales')
        }
      } else {
        message.warning('No puedes usar la vieja contraseña, crea una nueva')
      }
    }
  }

  return (
    <div
      style={{
        backgroundColor: '#1a2022',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ width: '300px', position: 'absolute', top: '35%' }}>
        <img
          src={tychoLogo}
          style={{
            marginLeft: 'auto',
            marginRight: 'auto',
            display: 'block',
            width: '300px',
            height: 'auto',
          }}
        />

        <div style={{ textAlign: 'center', maginTop: '20px' }}>
          <h1 style={{ color: 'white', fontSize: '16px' }}>Please change your temporary password</h1>
        </div>
        <div style={{ marginTop: '30px' }}>
          <Input
            onChange={(event) => setEmail(event.target.value)}
            disabled={true}
            prefix={<MailOutlined />}
            placeholder="Email"
            value={authData.email}
          />
        </div>

        <div style={{ marginTop: '10px', display: 'flex', position: 'relative' }}>
          <Password
            onChange={(event) => setPassword(event.target.value)}
            disabled={isLoggingIn}
            prefix={<LockOutlined />}
            placeholder="Temporary Password"
            value={password}
          />
          <Tooltip
            title="Fill this entry with the temporary password that we sent you in the Welcome email"
            placement="right"
            arrow
          >
            <HelpOutlineIcon className="cp-help-icon" />
          </Tooltip>
        </div>

        <div style={{ marginTop: '10px', display: 'flex', position: 'relative' }}>
          <Password
            onChange={(event) => {
              verifyPasswordStrength(event.target.value)
            }}
            disabled={isLoggingIn}
            prefix={<LockOutlined />}
            placeholder="New password"
            value={newPassword}
          />
          <Tooltip title="The new password must have a minimum of eight characters" placement="right" arrow>
            <HelpOutlineIcon className="cp-help-icon" />
          </Tooltip>
        </div>

        <div style={{ marginTop: '10px' }}>
          <Password
            onChange={(event) => {
              verifySamePassword(event.target.value)
            }}
            disabled={isLoggingIn}
            prefix={<LockOutlined />}
            placeholder="Confirm new password"
            value={confirmNewPassword}
            onPressEnter={submitLogin}
          />
        </div>

        <div style={{ marginTop: '10px', float: 'right', width: '100%' }}>
          <Button
            type="primary"
            onClick={submitLogin}
            disabled={isLoggingIn}
            style={{ marginTop: '10px', float: 'right', width: '100%' }}
          >
            Update Password
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ChangePassword
